<script lang="ts">
	import { Code, Network, Computer, Music4 } from 'lucide-svelte';
	import ReleaseGenerator from './lib/components/ReleaseGenerator.svelte';

	const pageTitle = 'DDEX ERN Generator';
</script>

<svelte:head>
	<title>{pageTitle}</title>
</svelte:head>

	<div class="min-h-screen bg-gray-50">
	<!-- Beautiful Navbar -->
	<nav class="navbar">
		<div class="container">
			<div class="flex items-center justify-between py-4">
				<!-- Logo/Brand -->
				<a href="/">
					<div class="navbar-brand">
							<div class="avatar avatar-md bg-black text-white">
								<Code size={16} />
							</div>
							<div>
								<div class="text-xl font-bold"><h1>DDEX ERN Generator</h1></div>
								<div class="text-xs text-gray-400 -mt-1">Creating beautiful XML since 2025</div>
							</div>
					</div>
				</a>

				<!-- Navigation Links -->
				<div class="navbar-nav">
					<a 
						href="https://ddex.net" 
						target="_blank" 
						rel="noreferrer" 
						class="btn btn-ghost btn-sm"
					>
						<Network size={16} />
						DDEX
					</a>
					<a 
						href="https://github.com/robbwebbb/" 
						target="_blank" 
						rel="noreferrer" 
						class="btn btn-ghost btn-sm"
					>
						<Computer size={16} />
						GitHub
					</a>
					<a 
						href="https://open.spotify.com/user/rob_webb" 
						target="_blank" 
						rel="noreferrer" 
						class="btn btn-ghost btn-sm"
					>
						<Music4 size={16} />
						Spotify
					</a>
				</div>
			</div>
		</div>
	</nav>

	<!-- Main Content -->
	<main class="container section">
		<div class="max-w-5xl mx-auto">
			<div class="card card-hover animate-fade-in">
				<div class="card-body p-8">
					<ReleaseGenerator />
				</div>
			</div>
		</div>
	</main>
</div>